import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Technologies">
                <h1>Revolutionary Technologies for a Changing World</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  At Tekrevol, we harness the power of revolutionary
                  technologies, employing a diverse range of programming
                  languages and platforms to create custom solutions that
                  perfectly align with the unique needs of our clients.
                </p>
                <ul>
                  <li>Emerging technology adoption</li>
                  <li>Cross-platform compatibility</li>
                  <li>Agile development process</li>
                  <li>Scalable infrastructure management</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
